<template>
  <div class="md-layout">
    <!-- 検索フォームカード -->
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>search</md-icon>
          </div>
          <h4 class="title">翻訳済みテキスト検索</h4>
        </md-card-header>
                 <md-card-content class="md-layout formLayout">
           <div class="md-layout md-layout-item md-size-50 md-xsmall-size-100">
             <label class="md-layout-item md-size-30 md-form-label md-xsmall-size-100">
               ブランド
             </label>
             <div class="md-layout-item md-xsmall-size-100">
               <brand-select v-model="brandId" :noSelectFlag="true"></brand-select>
             </div>
           </div>
           <div class="md-layout md-layout-item md-size-50 md-xsmall-size-100">
             <label class="md-layout-item md-size-30 md-form-label md-xsmall-size-100">
               日本語
             </label>
             <div class="md-layout-item md-xsmall-size-100">
               <md-field class="no-border">
                 <md-input v-model="searchNameJa" placeholder="日本語名を入力"></md-input>
               </md-field>
             </div>
           </div>
         </md-card-content>
                 <md-card-actions md-alignment="left" class="mt60 mx-auto no-border-top">
           <md-button class="md-success md-lg" @click="handleSearch">検索</md-button>
         </md-card-actions>
      </md-card>
    </div>
    
    <!-- 一覧表示カード -->
    <transition name="fade">
      <div class="md-layout-item md-size-100" v-if="resultFlag">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
              <md-icon>assignment</md-icon>
            </div>
            <h4 class="title">翻訳済みテキスト一覧</h4>
          </md-card-header>
          <md-card-content class="tipsVisible">
            <div class="dataTableWrapper">
              <div class="dataTable"> 
                <div class="tHead">
                  <div class="tHead_th col-brand">ブランド名</div>
                  <div class="tHead_th col-japanese">日本語</div>
                  <div class="tHead_th col-english">英語</div>
                  <div class="tHead_th col-chinese-sc">簡体字</div>
                  <div class="tHead_th col-chinese-t">繁体字</div>
                  <div class="tHead_th col-korean">韓国語</div>
                  <div class="tHead_th col-action taR">アクション</div>
                </div>
                <div v-for="item in tableData" :data-id="item.id" class="tItem" :key="item.id">
                  <div class="tItem_td col-brand commentBody">
                    <span class="text-ellipsis">{{ item.brandName }}</span>
                  </div>
                  <div class="tItem_td col-japanese commentBody">
                    <span class="text-ellipsis">{{ item.nameJa }}</span>
                  </div>
                  <div class="tItem_td col-english commentBody">
                    <span class="text-ellipsis">{{ item.nameEn }}</span>
                  </div>
                  <div class="tItem_td col-chinese-sc commentBody">
                    <span class="text-ellipsis">{{ item.nameCn }}</span>
                  </div>
                  <div class="tItem_td col-chinese-t commentBody">
                    <span class="text-ellipsis">{{ item.nameTw }}</span>
                  </div>
                  <div class="tItem_td col-korean commentBody">
                    <span class="text-ellipsis">{{ item.nameKo }}</span>
                  </div>
                  <div class="tItem_td col-action taR">
                    <md-button
                      class="md-just-icon md-warning mg2"
                      @click.native="handleDetail(item)">
                      <md-icon>dvr</md-icon>
                    </md-button>
                    <md-button
                      class="md-just-icon md-danger mg2"
                      @click.native="handleDelete(item)">
                      <md-icon>close</md-icon>
                    </md-button>
                  </div>
                </div>
              </div>
            </div>
          </md-card-content>
          <md-card-actions md-alignment="space-between">
            <div class="">
              <p class="card-category">全{{ pageData.totalCount | numberWithDelimiter}}件中 {{from | numberWithDelimiter}}件から {{to | numberWithDelimiter}}件を表示</p>
            </div>
            <Pagination class="Pagination-no-border Pagination-success"
              :currentPage="pageData.currentPage"
              :totalPage="pageData.totalPage"
              @get="getGlossaries">
            </Pagination>
          </md-card-actions>
        </md-card>
      </div>
    </transition>
  </div>
</template>

<script>
  import Pagination from '../components/additional/Pagination.vue'
  import BrandSelect from '../components/additional/BrandSelect.vue'
  import swal from 'sweetalert2'
  import router from '../packs/router.js'
  import alertMixin from '../mixins/alert.js'

  export default {
    mixins: [alertMixin],
    components: {
      Pagination,
      BrandSelect
    },
    computed: {
      to () {
        return (this.pageData.currentPage - 1) * 25 + this.tableData.length
      },
      from () {
        return (this.pageData.currentPage - 1) * 25 + 1
      }
    },
    data () {
      return {
        resultFlag: false,
        searchNameJa: '',
        brandId: '選択しない',
        pageData: {
          totalPage: 0,
          currentPage: 0,
          nextPage: null,
          prevPage: null,
          totalCount: 0
        },
        tableData: []
      }
    },
    methods: {
      handleSearch () {
        this.resultFlag = false
        this.getGlossaries(1)
      },

      getGlossaries (page) {
        var condition = {
          page: page,
          name_ja: this.searchNameJa,
          brand_id: this.brandId === '選択しない' ? '' : this.brandId
        }
        this.axios({
          method  : 'GET',
          url     : this.AdminApiUrl + '/glossaries',
          timeout : 30000,
          headers : {'Authorization': this.$Cookies.get('accessToken')},
          params: condition
        }).then(response => {
          if (response.data.data.length === 0) {
            this.resultFlag = false
            this.noSearchResults()
          } else {
            this.createList(response.data)
            this.pageData.totalPage = response.data.meta['total-pages']
            this.pageData.currentPage = response.data.meta['current-page']
            this.pageData.totalCount = response.data.meta['total-count']
            this.resultFlag = true
          }
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.tokenError()
          } else {
            this.dangerNotify('用語集情報を正しく取得できませんでした')
          }
        })
      },
      createList (obj) {
        var res = obj.data
        this.tableData.splice(0)
        for (var i in res) {
          var item = {
            id: res[i].id,
            nameJa: res[i].attributes['name-ja'],
            nameEn: res[i].attributes['name-en'],
            nameCn: res[i].attributes['name-cn'],
            nameTw: res[i].attributes['name-tw'],
            nameKo: res[i].attributes['name-ko'],
            brandName: res[i].attributes['brand-name'],
            createdAt: res[i].attributes['created-at']
          }
          this.tableData.push(item)
        }
      },
      handleDetail (item) {
        router.push({ path: '/admin/glossary/edit/' + item.id })
      },
      handleDelete (item) {
        swal({
          title: 'この翻訳済みテキストを削除してもよろしいですか?',
          text: `削除してしまうともとに戻すことは出来ません！`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'md-button md-success btn-fill',
          cancelButtonClass: 'md-button md-danger btn-fill',
          confirmButtonText: 'OK',
          buttonsStyling: false
        }).then((result) => {
          if(result.value){
            this.deleteGlossary(item.id)
          }
        });
      },
      deleteGlossary (id) {
        this.axios({
          method  : 'DELETE',
          url     : this.AdminApiUrl + '/glossaries/' + id,
          timeout : 30000,
          headers : {'Authorization': this.$Cookies.get('accessToken')}
        }).then(response => {
          this.deleteRow(id)
          var $this = this
          swal({
            title: '削除完了',
            text: `翻訳済みテキストを削除しました`,
            type: 'success',
            confirmButtonClass: 'md-button md-success btn-fill',
            buttonsStyling: false
          }).then (function () {
            $this.getGlossaries($this.pageData.currentPage)
          }) 
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.tokenError()
          } else {
            this.dangerNotify('用語集の削除に失敗しました')
          }
        })
      },
      deleteRow(id){
        let indexToDelete = this.tableData.findIndex((tableRow) => tableRow.id === id);
        if (indexToDelete >= 0) {
          this.tableData.splice(indexToDelete, 1)
        }
      }
    },
    destroyed() {
      sessionStorage.removeItem('brandSelect')
    }
  }
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.no-border .md-field::after,
.no-border .md-field::before {
  display: none !important;
}
.no-border-top {
  border-top: none !important;
}

/* テーブルカラム幅調整 */
.col-brand {
  width: 12% !important;
  min-width: 80px;
}
.col-japanese {
  width: 15% !important;
  min-width: 100px;
}
.col-english {
  width: 15% !important;
  min-width: 100px;
}
.col-chinese-s {
  width: 12% !important;
  min-width: 80px;
}
.col-chinese-sc {
  width: 12% !important;
  min-width: 80px;
}
.col-chinese-t {
  width: 12% !important;
  min-width: 80px;
}
.col-korean {
  width: 12% !important;
  min-width: 80px;
}
.col-action {
  width: 10% !important;
  min-width: 70px;
}

/* テーブル全体の調整 */
.dataTable {
  table-layout: fixed;
  width: 100%;
}
.tHead, .tItem {
  display: flex;
  width: 100%;
  align-items: center;
}
.tHead_th, .tItem_td {
  flex-shrink: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
  min-height: 48px;
}

/* テキスト省略記号対応 */
.text-ellipsis {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 100%;
  display: block;
  max-width: 100%;
}

.tItem_td.commentBody {
  padding-right: 8px;
}
</style> 